<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Login-->
    <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white" id="kt_login">
      <!--begin::Aside-->
      <div class="login-aside d-flex flex-column flex-row-auto" style="background-color: #dfe8ea;">
        <!--begin::Aside Top-->
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <!--begin::Aside header-->
          <a href="#" class="text-center mb-10">
            <img src="media/logos/logo2.png" class="logo-default max-h-80px"/>
          </a>
          <!--end::Aside header-->
          <!--begin::Aside title-->
          <h3 class="font-weight-bolder text-center font-size-h4 font-size-h1-lg" style="color: #56390f;">{{$t('AUTH.ICLOUD.NAME_TOP')}}
            <br />{{$t('AUTH.ICLOUD.NAME_FOOT')}}</h3>
          <!--end::Aside title-->
        </div>
        <!--end::Aside Top-->
        <!--begin::Aside Bottom-->
        <div class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center" style="background-image: url(media/svg/illustrations/login-visual-1.svg)"></div>
        <!--end::Aside Bottom-->
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div class="row align-items-center border-bottom">
          <label class="col-form-label col-xl-6 col-lg-6 font-weight-bolder">
            <div class="checkbox-inline">
              <template v-for="(item, i) in languages">
                <label class="checkbox checkbox-outline checkbox-success" :key="i" v-on:click="selectedLanguage(item.lang)">
                  <input type="checkbox" name="checkbox" :checked="isActiveLanguage(item.lang)"/>
                  <span></span>
                  {{item.name}}
                </label>
              </template>
            </div>
          </label>
          <div class="col-xl-6 col-lg-6 text-right">
            <router-link to="/inquiry">
              <button
                  class="btn btn-success font-weight-bold px-9 py-4 my-3 font-size-3"
              >
                {{$t('AUTH.GENERAL.INQUIRY_BUTTON')}}
              </button>
            </router-link>
          </div>
        </div>
        <!--begin::Content body-->
        <div class="d-flex flex-column-fluid flex-center pt-3">
          <router-view></router-view>
        </div>
        <!--end::Content body-->
        <!--begin::Content footer-->
<!--        <div class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0">-->
<!--          <a href="#" class="text-primary font-weight-bolder font-size-h5" v-on:click="openOrde(1)">{{$t('AUTH.GENERAL.PRIVACY')}}</a>-->
<!--          <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5" v-on:click="openOrde(1)">{{$t('AUTH.GENERAL.LEGAL')}}</a>-->
<!--          <a href="#" class="text-primary ml-10 font-weight-bolder font-size-h5" v-on:click="openOrde(1)">{{$t('AUTH.GENERAL.CONTACT')}}</a>-->
<!--        </div>-->
        <b-modal ref="tipWindow" hide-footer size="xl">
          <template v-slot:modal-header="{ close }">
            <h5>{{$t('ORDER.Information_Manage')}}</h5>
            <b-button size="sm" variant="outline-danger" @click="close()">
              {{$t('CRAFTVALUE.Close')}}
            </b-button>
          </template>
<!--          <div>{{$t('BOTTOM.About')}}</div>-->
<!--          <div>{{$t('BOTTOM.TEAM')}}</div>-->
<!--          <div>{{$t('BOTTOM.Contact')}}</div>-->
          <div>{{onlineWindowObj.chineseContent}}</div>
        </b-modal>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->
    </div>
    <!--end::Login-->
    <b-modal ref="tipsMsg" hide-footer>
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('AUTH.TIPS.MESSAGE')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="d-block">
        <div>
          <v-row>
            <v-col>
              <h5 class="text-left">
                <span class="text-danger" v-if="msgType && msgType == 'refresh'">{{$t('AUTH.TIPS.REFRESH')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'repeat'">{{$t('AUTH.TIPS.REPEAT')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'register'">{{$t('AUTH.TIPS.REGISTERTWO')}}</span>
                <span class="text-primary" v-if="msgType && msgType == 'success'">{{$t('AUTH.TIPS.SUCCESS')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'inexistence'">{{$t('AUTH.TIPS.INEXISTENCE')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'fail'">{{$t('AUTH.TIPS.FAIL')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'comfimPass'">{{$t('AUTH.TIPS.CONFIMPASS')}}</span>
                <span class="text-danger" v-if="msgType && msgType == 'consentClause'">{{$t('AUTH.TIPS.CONSENTCLAUSE')}}</span>
              </h5>
            </v-col>
          </v-row>
        </div>
      </div>
    </b-modal>
    <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
  </div>
</template>
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>
<script>
import i18nService from "@/core/services/i18n.service.js";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
export default {
  components:{
    KTStickyToolbar
  },
  data() {
    return {
      languages: i18nService.languages,
      msgType: "",
      onlineWindowObj:{},
    };
  },
  methods: {
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    selectedLanguage(languageVal) {
      i18nService.setActiveLanguage(languageVal);
      window.location.reload();
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
    openOrde(type) {
      const query = {};
      query.type = type;
      this.$axios.fetchPost("is/offer/selectOnlineWindow", query).then(result => {
         this.onlineWindowObj = result.data;
      }).catch(err => {alert(err)});
      this.$refs['tipWindow'].show()
    },
    openMessage(item) {
      this.msgType = item;
      this.$refs['tipsMsg'].show();
    }
  },
  computed: {
    activeLanguage() {
      return i18nService.getActiveLanguage();
    },
    user: {
      get () {
        return this.$store.getters.currentUser;
      }
    },
  },
}
</script>
